var map = {
	"./Asset1_lrg.png": 634,
	"./Asset2_lrg.png": 635,
	"./Asset3_lrg.png": 636,
	"./Asset4_lrg.png": 637,
	"./Asset5_lrg.png": 638,
	"./Asset6_lrg.png": 639,
	"./Asset7_lrg.png": 640
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 633;